jQuery(function() {
  
  jQuery('.shop-carousel').owlCarousel({
    loop: true,
    margin: 30,
    autoplay: true,
    nav: true,
    items: 4,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      900: {
        items: 2,
        margin: 20
      },
      1024: {
        items: 3
      },
      1300: {
        items: 4
      }
    }
     
  });


  var owl = jQuery(".product-slider");
  owl.owlCarousel({
    loop: true,
    nav: true,
    margin: 50,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1,
        margin: 10
      },
      1024: {
        items: 1,
        margin: 20
      },
      1200: {
        items: 1.05,
        margin: 30
      },
      1300: {
        items: 1.08,
        margin: 50
      }
    }
  });
});


var owl = jQuery('.contact-box-slider'),
            $nav = jQuery('.contact-info-box .contact-info-tab');
            $navMobile = $('.mobile_tab_dropdown');
            

        owl.owlCarousel({
            // stagePadding: 100,
            items: 1,
            margin: 10,
            dots: false
        });

        owl.on('changed.owl.carousel', function(event) {
            var idx =  event.item.index + 1;
            var $selectedNavItem = $nav.find('div:nth-child(' + idx  + ')');
            $selectedNavItem.addClass('active').siblings().removeClass('active')
        });

        $nav.find('div').each(function(idx) {
            $(this).on('click', function() {
                owl.trigger('to.owl.carousel', [idx, 500, true]);
            });
        });
        jQuery('.mobile_tab_dropdown').on("change", function() {
            var selectedIndex = this.selectedIndex;   
            owl.trigger('to.owl.carousel', [selectedIndex, 500, true]);
    });